// src/App.jsx
import { Routes, Route } from 'react-router-dom';

// Макет
import MainLayout from './components/MainLayout';

// Страницы
import LoginPage from './pages/auth/LoginPage';
import LogoutPage from './pages/auth/LogoutPage';
import NewsPage from './pages/NewsPage';
import SoundsPage from './pages/SoundsPage';
import HomePage from './pages/HomePage';
// import SoundsPage from "./pages/SoundsPage_with_UniversalTable";
import ProjectsPage from './pages/project/ProjectsPage';
import StatusAnalyticsPage from "./pages/analytics/StatusAnalyticsPage";
import AdminAnalyticsPage from './pages/analytics/AdminAnalyticsPage';
import EditThemesPage from './pages/analytics/EditThemesPage';
import AnalyticsPage from './pages/analytics/AnalyticsPage';
import AnalyticProjectPage from './pages/analytics/AnalyticProjectPage';
// import AnalyticsAllCallsPage from './pages/analytics/AnalyticsAllCallsPage';
import AnalyticsAllCallsPage from "./pages/analytics/AnalyticsAllCallsPage_with_UniversalTable";
import AnalyticsOperatorCallsPage from './pages/analytics/AnalyticsOperatorCallsPage';
import UserPage from './pages/users/UserPage';
import UsersPage from './pages/users/UsersPage';
import QualityFieldOptionsPage from "./pages/quality/QualityFieldOptionsPage";
import QualitySettingsPage from './pages/quality/QualitySettingsPage';
import AssessmentQualityPage from './pages/quality/AssessmentQualityPage';
import AnalyticsKKPage from './pages/quality/AnalyticsKKPage';
// import AssessmentChartsPage from './pages/quality/charts/AssessmentChartsPagex';
import AllAssessmentsPage from './pages/quality/AllAssessmentsPage';
import DynamicAssessmentsPage from './pages/quality/DynamicAssessmentsPage';
import AssessmentCustomerQualityPage from './pages/quality/AssessmentCustomerQualityPage';
// import AssessmentDynamicsChartsPage from './pages/quality/charts/AssessmentDynamicsChartsPagex';
import AnalyticsQualityAssessmentsPage from './pages/AnalyticsRA/AnalyticsQualityAssessmentsPage';
import AnalyticsRAHome from './pages/AnalyticsRA/AnalyticsRAHome';
import ProjectAnalytics from './pages/AnalyticsRA/ProjectAnalytics';
import SummaryAnalytics from './pages/AnalyticsRA/SummaryAnalytics';

// Защита маршрутов
import ProtectedRoute from './components/ProtectedRoute';
import AssessmentChartsPage from "./pages/quality/charts/AssessmentChartsPage";
import AssessmentDynamicsChartsPage from "./pages/quality/charts/AssessmentDynamicsChartsPage";


function App() {
  return (
    <MainLayout>
      <Routes>
        {/* Публичная страница */}
        <Route path="/login" element={<LoginPage />} />

        {/* Защищённые маршруты */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <HomePage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/logout"
          element={
            <ProtectedRoute>
              <LogoutPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/news"
          element={
            <ProtectedRoute requiredRoles={['analytics']} oneOfRoles={['admin', 'auditor']}>
              <NewsPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/sounds"
          element={
            <ProtectedRoute requiredRoles={['analytics']} oneOfRoles={['admin', 'auditor']}>
              <SoundsPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/analytics"
          element={
            <ProtectedRoute requiredRoles={['analytics']} oneOfRoles={['admin', 'auditor']}>
              <AnalyticsPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/analytics/stats"
          element={
            <ProtectedRoute requiredRoles={['analytics']} oneOfRoles={['admin', 'auditor']}>
              <AnalyticsQualityAssessmentsPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/analytics-ra"
          element={
            <ProtectedRoute requiredRoles={['analytics']} oneOfRoles={['admin', 'auditor']}>
              <AnalyticsRAHome />
            </ProtectedRoute>
          }
        />

        <Route
          path="/analytics-ra/project"
          element={
            <ProtectedRoute requiredRoles={['analytics']} oneOfRoles={['admin', 'auditor']}>
              <ProjectAnalytics />
            </ProtectedRoute>
          }
        />

        <Route
          path="/analytics-ra/summary"
          element={
            <ProtectedRoute requiredRoles={['analytics']} oneOfRoles={['admin', 'auditor']}>
              <SummaryAnalytics />
            </ProtectedRoute>
          }
        />

        <Route
          path="/analytics/project/:projectId"
          element={
            <ProtectedRoute requiredRoles={['analytics']} oneOfRoles={['admin', 'auditor']}>
              <AnalyticProjectPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/analytics/calls/:projectId"
          element={
            <ProtectedRoute requiredRoles={['analytics']} oneOfRoles={['admin', 'auditor']}>
              <AnalyticsAllCallsPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/analytics/operators/:projectId"
          element={
            <ProtectedRoute requiredRoles={['analytics']} oneOfRoles={['admin', 'auditor']}>
              <AnalyticsOperatorCallsPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/user/:userId"
          element={
            <ProtectedRoute oneOfRoles={['analytics', 'qc', 'qc_customer']} >
              <UserPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/users"
          element={
            <ProtectedRoute oneOfRoles={['admin', 'auditor']}>
              <UsersPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin-analytics"
          element={
            <ProtectedRoute requiredRoles={['analytics']} oneOfRoles={['admin']}>
              <AdminAnalyticsPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/status-analytics"
          element={
            <ProtectedRoute requiredRoles={['analytics']} oneOfRoles={['admin', 'auditor']}>
              <StatusAnalyticsPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/projects"
          element={
            <ProtectedRoute requiredRoles={['superuser']}>
              <ProjectsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/edit-themes"
          element={
            <ProtectedRoute requiredRoles={['analytics']} oneOfRoles={['admin', 'auditor']}>
              <EditThemesPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/quality-settings"
          element={
            <ProtectedRoute requiredRoles={['qc']} oneOfRoles={['admin', 'auditor']}>
              <QualitySettingsPage />
            </ProtectedRoute>
          }
        />
        
        <Route
          path="/quality-assessment-options"
          element={
            <ProtectedRoute requiredRoles={['qc']} oneOfRoles={['admin', 'auditor']}>
              <QualityFieldOptionsPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/quality-assessment"
          element={
            <ProtectedRoute requiredRoles={['qc']} oneOfRoles={['admin', 'auditor', 'operator']}>
              <AssessmentQualityPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/analytics-kk"
          element={
            <ProtectedRoute requiredRoles={['qc']} oneOfRoles={['admin', 'auditor', 'customer']}>
              <AnalyticsKKPage />
            </ProtectedRoute>
          }
        />
        
        <Route
          path="/assessment-charts/:id"
          element={
            <ProtectedRoute requiredRoles={['qc']} oneOfRoles={['admin', 'auditor']}>
              <AssessmentChartsPage />
            </ProtectedRoute>
          }
        />
          <Route
          path="/assessment-dynamics-charts/:id"
          element={
            <ProtectedRoute requiredRoles={['qc']} oneOfRoles={['admin', 'auditor']}>
              <AssessmentDynamicsChartsPage />
            </ProtectedRoute>
          }
        />
        
        <Route
          path="/all-assessments/:id"
          element={
            <ProtectedRoute requiredRoles={['qc']} oneOfRoles={['admin', 'auditor', 'customer']}>
              <AllAssessmentsPage />
            </ProtectedRoute>
          }
        />
        
        <Route
          path="/dynamic-assessments/:id"
          element={
            <ProtectedRoute requiredRoles={['qc']} oneOfRoles={['admin', 'auditor']}>
              <DynamicAssessmentsPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/quality-assessment-customer"
          element={
            <ProtectedRoute requiredRoles={['qc_customer']} oneOfRoles={['admin', 'customer', 'auditor']}>
              <AssessmentCustomerQualityPage />
            </ProtectedRoute>
          }
        />


        {/*<Route*/}
        {/*  path="/quality-assessment-options"*/}
        {/*  element={*/}
        {/*    <ProtectedRoute requiredRoles={['qc']} oneOfRoles={['admin', 'customer']}>*/}
        {/*      <QualityFieldOptionsPage />*/}
        {/*    </ProtectedRoute>*/}
        {/*  }*/}
        {/*/>*/}
        {/* Редирект на основную страницу в зависимости от прав пользователя */}


        <Route path="*" element={<ProtectedRoute redirectDefault={true} />} />
      </Routes>
    </MainLayout>
  );
}

export default App;
